<script lang="ts">
    import './button-styles.less';
    import type {ComponentSize, ButtonStyle} from '../types';
    import {focusOnMount} from 'shared/value-editors/internal/shared/use.focus-on-mount';

    export let href: string;
    export let buttonStyle: ButtonStyle = 'default';
    export let buttonSize: ComponentSize = 'md';
    export let isBlock = false;
    export let isDisabled = false;
    export let additionalClasses = '';
    export let id: string | null = null;
    export let title: string | null = null;
    export let dataQa: string | null = null;
    export let noWrap = false;
    export let focused = false;

    $: buttonClasses = `btn btn-${buttonStyle} btn-${buttonSize} ${isBlock ? 'btn-block' : ''}`;
</script>

<a {href}
   {id}
   {title}
   data-qa={dataQa}
   class="kp-button-style-link {buttonClasses} {additionalClasses}"
   class:disabled={isDisabled}
   class:no-text-wrap={noWrap}
   {...$$restProps}
   use:focusOnMount={focused}
   on:click
   on:focus
   on:blur
   on:contextmenu
   on:dblclick
   on:focusin
   on:focusout
   on:keydown
   on:keyup
   on:mouseenter
   on:mouseleave
   on:mousemove
   on:mouseout
   on:mouseover
   on:mouseup
   on:toggle>
    <slot/>
</a>

<style lang="less">
    .kp-button-style-link {
        white-space: normal;

        &.no-text-wrap {
            white-space: nowrap;
        }
    }

    .btn-link {
        color: darkblue;
    }
</style>